import { Box, Button } from '@chakra-ui/react';
import { Icon, IconLib, IconMap } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from '../components/TextBlock';

type NavbarMenuItemProps = {
  label: string;
  route?: string;
  href?: string;
  icon: keyof typeof IconMap;
  iconVariant?: IconLib;
  subMenu?: {
    icon: keyof typeof IconMap;
    label: string;
    route: string;
  }[];
  showBorder?: boolean;
  tag?: string;
};

export const NavbarMenuItem: React.FC<NavbarMenuItemProps> = ({
  icon = 'bolt',
  iconVariant = 'regular',
  href,
  label,
  route,
  showBorder = true,
  tag,
}) => {
  const isCurrentRoute = route ? window.location.pathname === route : false;

  return (
    <Box
      p="2px"
      background={isCurrentRoute && showBorder ? 'linear-gradient(to bottom, #63AAFF, #C7E0FF, #C4A8FF)' : 'none'}
      borderRadius={'8px'}
      borderColor={'white'}
      position="relative"
      _hover={{ background: showBorder ? 'linear-gradient(to bottom, #63AAFF, #C7E0FF, #C4A8FF)' : undefined }}>
      <Button
        as={Link}
        to={route ?? href ?? ''}
        borderRadius={'6px'}
        backgroundColor={'white'}
        alignItems="center"
        leftIcon={<Icon icon={icon} boxSize="16px" variant={iconVariant} />}
        colorScheme="black"
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontWeight="normal"
        lineHeight={'16px'}
        variant="ghost">
        {label}
      </Button>
      {tag && (
        <TextBlock
          as="span"
          position="absolute"
          bottom={0}
          left={'41px'}
          fontSize={'6px'}
          textTransform={'uppercase'}
          backgroundColor={'gray.300'}
          borderRadius={'5px'}
          pointerEvents={'none'}
          color="white"
          lineHeight={'11px'}
          zIndex={1}
          fontWeight={'normal'}
          px="5px">
          {tag}
        </TextBlock>
      )}
    </Box>
  );
};
